<section
	class="bg-white h-full flex gap-4 rounded-xl flex-col [&>*]:px-6 [&>*:last-child]:pb-6"
	[ngClass]="class"
>
	<div class="border-b border-gray-200 py-4">
		<h3>{{ title }}</h3>
	</div>
	<ng-content></ng-content>
</section>
